export const SERVICE_HEADER = [
  "student",
  "parent",
  "school",
  "company",
  "driver",
  // "parent",
  "serviceFee",
  "remainedDay",
  "serviceStatus",
  "approveStatus",
  "factors",
  "setting",
];
export const SERVICE_HEADER_UNKNOWN_DRIVER = [
  "student",
  "parent",
  "school",
  "company",
  "description",
  "serviceFee",
  "remainedDay",
  "serviceStatus",
  "approveStatus",
  "factors",
  "setting",
];
export const SERVICE_HEADER_FOR_COMPANY = [
  "student",
  "parent",
  "school",
  "driver",
  // "parent",
  "serviceFee",
  "remainedDay",
  "serviceStatus",
  "approveStatus",
  "factors",
  "setting",
];
export const SERVICE_HEADER_FOR_COMPANY_UNKNOWN_DRIVER = [
  "student",
  "parent",
  "school",
  "description",
  "serviceFee",
  "remainedDay",
  "serviceStatus",
  "approveStatus",
  "factors",
  "setting",
];
export const SCHOOL_HEADERS = [
  "school",
  "schoolGender",
  "grade",
  "city",
  "province",
  "status",
  "setting",
];
export const DRIVER_HEADERS = [
  "driver",
  "parentSatisfaction4Driver",
  "tagNumber",
  "plateNumber",
  "nationalCode",
  'archiveStatus',
  "status",
  "docsStatus",
  "setting",
];
export const DRIVER_HEADERS_COMPANY = [
  "driver",
  "tagNumber",
  "plateNumber",
  "nationalCode",
  "status",
];
export const SERVICE_HEADER_FOR_DRIVER = [
  "student",
  "parent",
  "dateFrom",
  "dateTo",
  "status",
  "servicePrice",
  "options",
];
export const SERVICE_HEADER_FOR_ADMIN = [
  "student",
  "parent",
  "dateFrom",
  "dateTo",
  "servicePrice",
];
export const COMPANY_DIPOSIT_DRIVER_LIST = [
  "driver",
  "tagNumber",
  "تعداد دانش‌آموز",
  "فیمت کل",
  "سهم شرکت",
  "",
];
export const COMPANY_DIPOSIT_DRIVER_REPORT_LIST = [
  "تعداد فاکتور",
  "تعداد دانش‌آموز",
  "فیمت کل",
  "سهم شرکت",
];
export const COMPANY_DIPOSIT_DRIVER_REPORT_FACTOR_LIST = [
  "اولیاء",
  "دانش‌آموز",
  "فیمت",
  "تاریخ پرداخت",
];
export const SHOW_INFO_DRIVER_TRANSACTION = [
  "student",
  "parent",
  "date",
  "status",
  "payer",
  "payWay",
  "servicePrice",
];
export const SHOW_DETAILS_DRIVER_FINANCIAL_REPORT: Array<string> = [
  "student",
  "parent",
  "تاریخ شروع",
  "تاریخ پایان",
  "payWay",
  "payer",
  "status",
  "servicePrice",
];
export const DRIVER_CLOSED_FACTOR_HEADER = [
  "student",
  "parent",
  "dateFrom",
  "dateTo",
  "price",
];
export const PAY_SERVICE_HEADER_TABLE = [
  "select",
  "dateFrom",
  "dateTo",
  "servicePrice",
];
export const ALL_SERVICE_FOR_DRIVER = [
  "student",
  "parent",
  "school",
  "servicePrice",
  "remainedDay",
  "setting",
];
export const ALL_SERVICE_FOR_DRIVER_2 = [
  "select",
  "student",
  "school",
  "servicePrice",
  "remainedDay",
  "setting",
];
export const PARENT_HEADERS = ["parent", 'archiveStatus', "province", "city", "setting"];
export const COMPANY_HEADERS = [
  "companyName",
  "companyContractorName",
  "status",
  "docsStatus",
  "setting",
];
export const COMPANY_HEADERS_FOR_MUNICIPALITY = [
  "companyName",
  "companyContractorName",
  "status",
  "docsStatus",
  "setting",
];
export const COMPANY_HEADERS_FOR_ADMIN = [
  'companyName',
  'companyContractorName',
  'educationName',
  'status',
  'docsStatus',
  'deptAdmin2Company',
  'deptCompany2Admin',
  'setting',
];
export const GOVENMENTSHIP_HEADERS = ["governmentShip", "province", ""];
export const SUPER_AGENT_HEADERS = ["superAgent", "province", "city", ""];
export const ADMIN_HEADERS = [
  "firstNameLastName",
  "phoneNumber",
  "",
  "operate",
];
export const Ticket_HEADERS = [
  "row",
  "user",
  "title",
  "trackingCode",
  "status",
  "createDate",
  "operate",
];
export const SUPER_AGENT_PROVINCE_HEADERS = ["superAgent", "province", ""];
export const ABSENT_HEADERS = [
  "student",
  "driver",
  "absentDate",
  "changeStatus",
  "serviceStatus",
  "absentStatus",
  "",
];
export const LOG_HEADERS = [
  "student",
  "driver",
  "changeStatusFrom",
  "changeStatusTo",
  "changeDate",
];

export const FINANCIAL_GROUP_HEADERS = [
  "financialGroupName",
  "financialPercent",
  "companyFee",
  "period",
  "operate",
]

export const COMPANY_FINANCIAL_FACTORS_COMPANY = [
  'driver',
  'parent',
  'student',
  'price',
  'shareCompanyAdnAdmin',
  'payerType',
  'status',
  'paydAt',
  'createdAt',
];

export const FINANCIAL_CHILD_GROUP_HEADERS = ["user", "financialPercent"];
export const INVOICE_HEADERS = ["row", "price", "status", "dateFrom", "dateTo"];
export const TRANSACTION_TABLE_HEADER = [
  "row",
  "transactionType",
  "user",
  "student",
  "price",
  "transactionDate",
  "for",
  "factorCount",
  "paymentGateway",
  "payId",
  "company",
  "city",
  "transactionStatus",
  "options",
];
export const DEBT_TO_DRIVER_TABLE_HEADER = [
  "row",
  "driverName",
  "studentName",
  "driverPhoneNumber",
  "price",
  "factorCount",
  "",
];
export const PAY_ADMIN_TO_DRIVER = [
  "row",
  "select",
  "driverName",
  "driverPhoneNumber",
  "shabaNumber",
  "price",
  "requestTime",
  "status",
  "",
];
export const WITHDRAWAL_COMPANY_SCREEN = [
  "row",
  "select",
  "companyInfo",
  "shabaNumber",
  "price",
  "requestTime",
  "status",
  "",
];
export const PARENT_TRANSACTION = [
  "row",
  "parent",
  "service",
  "driver",
  "price",
  "transactionTime",
  "payModel",
  "transactionType",
];
export const PAYMENT_ONLINE_4_COMPANY = [
  'row',
  'select',
  'company',
  'driver',
  'parent',
  'price',
  'shareCompanyAdmin',
  'transactionTime',
  'transactionType',
];
export const APPROVE_PARENT_TRANSACTION = [
  "row",
  "parent",
  "service",
  "driver",
  "price",
  "transactionTime",
  "transactionType",
  "approve/cancel",
];
export const REJECTED_PARENT_TRANSACTION = [
  "row",
  "parent",
  "service",
  "driver",
  "price",
  "transactionTime",
  "transactionType",
  // "approve/cancel",
];
export const DRIVER_TRANSACTION = [
  "row",
  "driver",
  "allServicePrice",
  "paidPrice",
  "type",
  "shareCompanyAdmin",
  "shareAdmin",
  "factorCount",
  "paierType",
  "transactionTime",
  "",
];
export const ONLINE_DRIVER_TRANSACTION = [
  "row",
  "driver",
  "parent",
  "student",
  "price",
  "زمان پرداخت",
  "status",
  // "approve/cancel",
];
export const WITHDRAWALS_ADMIN = [
  'row',
  'select',
  'admin',
  'price',
  'شماره شبا',
  'نام بانک',
  'status',
  'approve/cancel',
];
export const WITHDRAWALS_COMPANY = [
  'row',
  'select',
  'admin',
  'price',
  'شماره شبا',
  'نام بانک',
  'status',
  'approve/cancel',
];
export const ONLINE_PARENT_TRANSACTION = [
  "row",
  "parent",
  "student",
  "driver",
  "price",
  "زمان پرداخت",
  "status",
  // "approve/cancel",
];
export const DRIVER_CLOSED_FACTOR = [
  "row",
  "service",
  "allServicePrice",
  "paidPrice",
  "type",
  "shareCompanyAdmin",
  "shareAdmin",
  "factorCount",
  "transactionTime",
];
export const COMPANY_FACTOR_LIST = [
  "row",
  "driverName",
  "studentName",
  "price",
  "dateFrom",
  "dateTo",
  "status",
];
export const LOCATION_PROVINCE_TABLE = [
  "name",
  "options",
];
export const LOCATION_CITY_TABLE = [
  "name",
  "province",
  "options",
];
export const LOCATION_AREA_TABLE = [
  "name",
  "province",
  "city",
  "options",
];
export const LOCATION_NEIGHBORHOOD_TABLE = [
  "name",
  "province",
  "city",
  "area",
  "options",
];
export const DEBTS_TABLE_HEADER = [
  "row",
  "phoneNumber",
  "userType",
  "price",
  "factorCount",
  "",
];
export const MICRO_TRANSACTION_TABLE_HEADER = [
  "row",
  "amount",
  "microTransactionType",
  "recipient",
  "status",
];
export const WITHDRAWAL_TABLE_HEADER = [
  "row",
  "withdrawer",
  "role",
  "price",
  "shabaNumber",
  "bank",
  "province/city",
  "trackingCode",
  "status",
  "approve/reject",
];

export const ACADEMIC_YEAR_TABLE = ["name", "key", "startAt", "endAt", "isCurrent", "options"];
